/**
 * Used to define featured TechDocs entities for display on the homepage and techdocs landing page.
 */
export const featuredTechDocs = [
  { name: 'machx', onHomepage: true },
  { name: 'backstage', onHomepage: false },
  { name: 'architectural-decision-record-submission', onHomepage: true },
  { name: 'mcs-accelerator', onHomepage: true },
  { name: 'threads', onHomepage: true },
  { name: 'erb', onHomepage: true },
  { name: 'hapi', onHomepage: true },
  { name: 'event-platforms', onHomepage: true },
];
